/**
 * Product Recommendations Responsive Dots
 * Handles showing the correct number of dots based on screen size
 */
class ProductRecommendationsDots {
  constructor() {
    this.init();
  }

  init() {
    // Initial setup with a delay to ensure slideshow is ready
    setTimeout(() => {
      this.setupAllCarousels();
    }, 1000); // Increased delay to ensure slideshow is fully ready

    // Listen for window resize events
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  setupAllCarousels() {
    // Find all product recommendations carousels
    const carousels = document.querySelectorAll('.resource-list__carousel[data-desktop-dots]');
    
    console.log('Found carousels:', carousels.length);
    
    carousels.forEach(carousel => {
      this.setupResponsiveDots(carousel);
    });
  }

  setupResponsiveDots(carousel) {
    const desktopDots = parseInt(carousel.dataset.desktopDots) || 1;
    const mobileDots = parseInt(carousel.dataset.mobileDots) || 1;
    
    // console.log('Setting up carousel with:', { desktopDots, mobileDots });
    
    // Try to get the slideshow controls with retry logic
    this.waitForSlideshowControls(carousel, desktopDots, mobileDots);
  }

  waitForSlideshowControls(carousel, desktopDots, mobileDots, attempts = 0) {
    const maxAttempts = 10;
    
    // Get the slideshow controls
    const slideshowControls = carousel.querySelector('slideshow-controls');
    if (!slideshowControls && attempts < maxAttempts) {
      setTimeout(() => {
        this.waitForSlideshowControls(carousel, desktopDots, mobileDots, attempts + 1);
      }, 200);
      return;
    }

    if (!slideshowControls) {
      console.warn('Slideshow controls not found after maximum attempts');
      return;
    }

    // Get the dots container
    const dotsContainer = slideshowControls.querySelector('.slideshow-controls__dots');
    if (!dotsContainer && attempts < maxAttempts) {
      setTimeout(() => {
        this.waitForSlideshowControls(carousel, desktopDots, mobileDots, attempts + 1);
      }, 200);
      return;
    }

    if (!dotsContainer) {
      console.warn('Dots container not found after maximum attempts');
      return;
    }

    // Get all dot items
    const dotItems = dotsContainer.querySelectorAll('li');
    
    // Update dots visibility
    this.updateDotsVisibility(dotItems, desktopDots, mobileDots);
  }

  updateDotsVisibility(dotItems, desktopDots, mobileDots) {
    // Get current window width
    const windowWidth = window.innerWidth;
    
    // By default show desktop dots, only switch to mobile if width < 749px
    const isMobile = windowWidth < 749;
    const maxDots = isMobile ? mobileDots : desktopDots;

   

    dotItems.forEach((item, index) => {
      if (index < maxDots) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  }

  handleResize() {
    // Debounce resize events
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.setupAllCarousels();
    }, 250);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductRecommendationsDots();
  });
} else {
  new ProductRecommendationsDots();
}

// Also initialize for dynamically loaded content
document.addEventListener('shopify:section:load', (event) => {
  if (event.target && event.target.querySelector('.resource-list__carousel[data-desktop-dots]')) {
    new ProductRecommendationsDots();
  }
});

// Initialize when slideshow components are ready
document.addEventListener('slideshow:ready', () => {
  new ProductRecommendationsDots();
});
